var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDriveIcon = function SvgDriveIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 15H3.75C2.50725 15 1.5 13.9928 1.5 12.75V3.75H14.25C15.4928 3.75 16.5 4.75725 16.5 6V12.75C16.5 13.9928 15.4928 15 14.25 15Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 3.75H1.5V3C1.5 2.17125 2.17125 1.5 3 1.5H6.4185C7.06425 1.5 7.63725 1.91325 7.84125 2.526L8.25 3.75Z",
    fill: "#E0E0E0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDriveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "drive-icon.9dc8f9049cf41ec4d131b6c31ffdf2b1.svg";